import React from 'react';
import PropTypes from 'prop-types';
//import clsx from 'clsx';
//import { makeStyles } from '@material-ui/styles';


import { 
    Button, 
    Dialog, 
    DialogActions,
    DialogContent,
    DialogContentText,
    // ListItemText, 
    // ListItem, 
    // List, 
    // Divider, 
    // AppBar, 
    // Toolbar, 
    // IconButton, 
    // Typography, 
    // Slide,
    // TextField,
    // MenuItem
  } from '@material-ui/core';
  import CloseIcon from '@material-ui/icons/Close';

// const useStyles = makeStyles(theme => ({
//   root: {
//   },
// }));

const SimplePopup = props => {
  //const { className, onChange, style, ...rest } = props;
  const { title, openPopup, onClickClose, onClickOk } = props;

  //const classes = useStyles();

  return (
    <Dialog
        open={openPopup}
        onClose={onClickClose}
        aria-describedby="alert-dialog-description"
        >
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {title}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClickOk} color="primary" autoFocus>
            확인
            </Button>
            <Button onClick={onClickClose} color="primary">
            취소
            </Button>
        </DialogActions>
    </Dialog>
  );
};

SimplePopup.propTypes = {
//   className: PropTypes.string,
//   onChange: PropTypes.func,
//   style: PropTypes.object
    title: PropTypes.string,
    openPopup: PropTypes.bool, 
    onClickClose: PropTypes.func, 
    onClickOk: PropTypes.func
};

export default SimplePopup;
